import HttpService from "./HttpService";
const API_ENDPOINT = "/area";

const AreaService = {
  async fetch() {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchPaginated(pageConfig) {
    const pageConfigParams = new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(
        `${API_ENDPOINT}-paginated?${pageConfigParams}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async add(data) {
    try {
      const response = await HttpService.post(API_ENDPOINT, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async edit(id) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/${id}/edit`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async update(areaId, data) {
    try {
      const response = await HttpService.put(`${API_ENDPOINT}/${areaId}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async delete(areaId) {
    try {
      const response = await HttpService.delete(`${API_ENDPOINT}/${areaId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default AreaService;
